import React from 'react';
import { connect, } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from '../../utils/withRouter';
import PropTypes from 'prop-types';
// Form libs
import { Formik, Form } from 'formik';
// Actions
import {
    addInquiryText,
    changeConsent,
    setTargetSystems
} from '../../actions/actionCreators';
// Styles
import './InquiryForm.css';
// Intl
import {
    FormattedMessage,
    injectIntl
} from "react-intl";

class InquiryForm extends React.Component {
    render() {
        let translations = this.props.intl.messages;
        let inquiryData = this.props.inquiryData;
        let targetSystems = this.props.targetSystems;
        let inquiryType = inquiryData.inquiryType;
        let selectedSystems = targetSystems.reduce((obj, item) => ({ ...obj, ['system_' + item.id]: inquiryData.targetSystems.includes(item.id) }), {});

        return (
            <div className="flex-center-center">
                <h2 className="form-text">
                    <span>
                        <FormattedMessage id={inquiryType.name} defaultMessage="Inquiry type" />
                    </span>
                </h2>
                <p>
                    <FormattedMessage id={inquiryType.text} defaultMessage="Description of inquiry" />
                </p>
                <Formik
                    initialValues={{
                        text: inquiryData.inquiry || '',
                        isPrivacyConsent: inquiryData.isPrivacyConsent || false,
                        ...selectedSystems
                    }}
                    onSubmit={(values) => {
                        this.props.addInquiryText(values.text);
                        this.props.changeConsent(values.isPrivacyConsent);
                        let selectedSystems = targetSystems.filter(x => values['system_' + x.id]).map(x => x.id);
                        this.props.setTargetSystems(selectedSystems);
                        
                        this.props.router.navigate('/form');
                    }}>
                    {({
                        values,
                        touched,
                        errors,
                        handleChange,
                        handleBlur
                    }) => (
                        <Form className="inquiry-form">
                            <div className="systems-wrapper">
                                <div className="column">
                                    {this.renderTargetSystems(targetSystems.slice(0, Math.ceil(targetSystems.length / 2)), values, handleChange, handleBlur, errors, touched)}
                                </div>
                                <div className="column">
                                    {this.renderTargetSystems(targetSystems.slice(Math.ceil(targetSystems.length / 2)), values, handleChange, handleBlur, errors, touched)}
                                </div>
                            </div>
                            <div className="textarea-wrapper">
                                <textarea
                                    id="text"
                                    placeholder={translations[inquiryType.placeholder]}
                                    type="textarea"
                                    value={values.text}
                                    maxLength={200}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={errors.text && touched.text ? 'textarea error' : 'textarea'}
                                />
                                {errors.text && touched.text && <div className="input-feedback">{errors.text}</div>}
                            </div>

                            <div className="checkbox-wrapper">
                                <label className="label-container" htmlFor="isPrivacyConsent">
                                    <input
                                        id="isPrivacyConsent"
                                        name="isPrivacyConsent"
                                        type="checkbox"
                                        value={values.isPrivacyConsent}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={errors.isPrivacyConsent && touched.isPrivacyConsent ? 'checkbox error' : 'checkbox'}
                                    />
                                </label>
                                {errors.isPrivacyConsent && touched.isPrivacyConsent && <div className="input-feedback">{errors.isPrivacyConsent}</div>}
                            </div>

                            <div className="submit-wrapper">
                                <button type="submit">
                                    <FormattedMessage id="submitNext" defaultMessage="Submit" />
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }

    renderTargetSystems(targetSystems, values, handleChange, handleBlur, errors, touched) {
        return targetSystems.map((targetSystem, index) => {
            return (
                <div className='row' key={index}>
                    <label htmlFor={ 'system_' + targetSystem.id }>
                        <FormattedMessage id={targetSystem.title} defaultMessage="Target system" />
                    </label>
                    <input
                        id={ 'system_' + targetSystem.id }
                        name={ 'system_' + targetSystem.id }
                        type="checkbox"
                        checked={values['system_' + targetSystem.id]}
                        value={values['system_' + targetSystem.id]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={errors['system_' + targetSystem.id] && touched['system_' + targetSystem.id] ? 'checkbox error' : 'checkbox'}
                    />
                </div>
            );
        })
}
}

InquiryForm.propTypes = {
    targetSystems: PropTypes.array.isRequired
};

let mapStateToProps = state => ({
    inquiryData: state.inquiryData
});

export default withRouter(injectIntl(compose(
    connect(mapStateToProps, {
        addInquiryText,
        changeConsent,
        setTargetSystems
}))(InquiryForm)));
